import { render, staticRenderFns } from "./ShippingAreaTypeSelect.vue?vue&type=template&id=2af52409&"
import script from "./ShippingAreaTypeSelect.vue?vue&type=script&lang=ts&"
export * from "./ShippingAreaTypeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports